import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getShopCategories } from "../../../network/service/ShopService";
import ProductImage from "../components/ProductImage";
import ShopHeader from "../components/ShopHeader";
import { ErrorState } from "../components/States";
import StorePicker from "../components/StorePicker";
import { useShopStore } from "../hooks/useShopStore";
import "../shop.css";

const splitLocal = (name) => {
  const match = name.match(/^(.*?)\s*\(([^()]*[ఀ-౿][^()]*)\)\s*$/);
  return match ? { name: match[1], localName: match[2].trim() } : { name, localName: null };
};

/** Shop entry: pick the store and a sub-category (e.g. Pulses & Dal). */
export default function ShopHome() {
  const navigate = useNavigate();
  const { storeId, stores, choose } = useShopStore();
  const [state, setState] = useState({ categories: [], status: "loading", error: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, status: "loading" }));
    getShopCategories()
      .then((categories) => alive && setState({ categories, status: "ready", error: null }))
      .catch((error) => alive && setState({ categories: [], status: "error", error }));
    return () => {
      alive = false;
    };
  }, [attempt]);

  return (
    <div className="ep-shop">
      <ShopHeader title="Shop" subtitle="Customer view of the EatProtein catalogue" />
      <StorePicker stores={stores} storeId={storeId} onChoose={choose} />

      {state.status === "error" && (
        <ErrorState error={state.error} title="Unable to load categories" onRetry={() => setAttempt((n) => n + 1)} />
      )}
      {state.status === "loading" && (
        <div className="ep-categories" role="status" aria-label="Loading categories">
          {Array.from({ length: 12 }, (_, i) => (
            <div key={i} className="ep-skel" style={{ height: 120, borderRadius: 14 }} />
          ))}
        </div>
      )}
      {state.categories.map((category) =>
        category.subCategories.length ? (
          <section key={category.id} aria-labelledby={`cat-${category.id}`}>
            <h2 id={`cat-${category.id}`} className="ep-section-title" style={{ padding: "18px 16px 0" }}>
              {splitLocal(category.name).name}
            </h2>
            <div className="ep-categories">
              {category.subCategories.map((sub) => {
                const { name, localName } = splitLocal(sub.name);
                return (
                  <button
                    key={sub.id}
                    type="button"
                    className="ep-category"
                    onClick={() => navigate(`/shop/category/${sub.id}${storeId ? `?store=${storeId}` : ""}`)}
                  >
                    <ProductImage path={sub.imagePath} alt="" />
                    <span>{name}</span>
                    {localName && <span className="ep-local" lang="te">{localName}</span>}
                  </button>
                );
              })}
            </div>
          </section>
        ) : null,
      )}
    </div>
  );
}
